import axios from '../utils/axios';

export default function updateSearchFlaggedUser (adminId, id, data) {
    return axios.post(`/admin/${adminId}/search/flagged-users/${id}`, data);
}